jQuery(document).on("facetwp-loaded", function () {
  // Listen for clicks on pager facet links
  jQuery(".facetwp-pager").on("click", "a", function (event) {
    // Scroll to the top of the facetwp-template element
    jQuery("html, body").animate(
      {
        scrollTop: jQuery(".facetwp-template").offset().top - 230,
      },
      500
    )
  })
})

jQuery(document).ready(function ($) {
  var currentUrl = window.location.href
  if (currentUrl.includes('/blog/?_blog_categories=')) {
    $('html, body').animate({
      scrollTop: $('.facetwp-template').offset().top - 246,
    }, 500)
  }
})


jQuery(document).ready(function ($) {
  var currentUrl = window.location.href
  if (currentUrl.includes('/recipes/?_bluebird_ingredients=')) {
    $('html, body').animate({
      scrollTop: $('.facetwp-template').offset().top - 246,
    }, 500)
  }
})

